import React, { FC, useRef, useState } from 'react';
import { addComma } from 'src/utils/common';
import IconButton from 'src/components/atoms/buttons/IconButton';
import NoResult from 'src/components/molecules/table/NoResult';
interface Props {
  data: any;
  viewType?: string;
  modifyItemEvt: (item: any) => void;
  deleteItemEvt: (item: any) => void;
}
const CreditGridList: FC<Props> = ({ data, viewType, modifyItemEvt, deleteItemEvt }) => {
  const viewData = data || [];
  const deleteEvt = (item: any) => {
    deleteItemEvt(item);
  };
  const modifyEvt = (item: any) => {
    modifyItemEvt(item);
  };
  return (
    <div className="_table_grid_layout _fix">
      <div className="_grid">
        <div className="_fix_grid">
          <div className="_fix_div">
            <div className="_label _fix">
              {viewType === 'modify' ? (
                <>
                  <div className="_col _wd_n01">
                    <div className="_tit"></div>
                  </div>
                </>
              ) : (
                ''
              )}
              <div className="_col _wd_n2">
                <div className="_cont">
                  <div className="_i_row _i_h0">
                    <div className="_i_col">국세청자료</div>
                  </div>
                </div>
              </div>

              <div className="_col _wd_n0">
                <div className="_cont">
                  <div className="_i_row _i_h0">
                    <div className="_i_col">성명</div>
                  </div>
                </div>
              </div>
              <div className="_col _wd_n1">
                <div className="_cont">
                  <div className="_i_row _i_h0">
                    <div className="_i_col">일반</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="_content">
              {viewData.map((cardData: any, idx: number) => {
                const item: any = cardData.cardData || {};
                return (
                  <div className="_row _i_h2" key={idx}>
                    {viewType === 'modify' ? (
                      <>
                        <div className="_col _wd_n01">
                          <div className="_cont">
                            <div className="_i_row ">
                              <div className="_i_col _w_p_50  _bor_r">
                                <div className="_btn">
                                  <IconButton
                                    clickEvent={e => modifyEvt(cardData)}
                                    icon="ri-edit-box-line"
                                    status=""
                                    type="type2"
                                    styleDef={{
                                      width: '22px',
                                      height: '22px',
                                      border: '0px',
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="_i_col _w_p_50">
                                <div className="_btn">
                                  <IconButton
                                    clickEvent={e => deleteEvt(cardData)}
                                    icon="ri-delete-bin-2-line"
                                    status=""
                                    type="type2"
                                    styleDef={{
                                      width: '22px',
                                      height: '22px',
                                      border: '0px',
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      ''
                    )}
                    <div className="_col _wd_n2">
                      <div className="_cont">
                        <div className="_i_row ">
                          <div className="_i_col _icon">
                            {item.is_htx_pdf === 'Y' ? (
                              <i className="ri-checkbox-circle-line" />
                            ) : (
                              <i className="ri-checkbox-blank-circle-line" />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="_col _wd_n0">
                      <div className="_tit">{cardData.name}</div>
                    </div>
                    <div className="_col _wd_n1">
                      <div className="_cont">
                        <div className="_i_row ">
                          <div className="_i_col _w_p_50  _bor_n">
                            {addComma(item.use_place_cd01)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="_scroll_div scroll_style_t2">
            <div className="">
              <div className="_label">
                <div className="_col _wdp_4">
                  <div className="_cont">
                    <div className="_i_row ">
                      <div className="_i_col">전통시장</div>
                    </div>
                  </div>
                </div>
                <div className="_col _wdp_4">
                  <div className="_cont">
                    <div className="_i_row _i_h0">
                      <div className="_i_col">대중교통</div>
                    </div>
                  </div>
                </div>
                <div className="_col _wdp_4">
                  <div className="_cont">
                    <div className="_i_row _i_h0">
                      <div className="_i_col">도서 공연등</div>
                    </div>
                  </div>
                </div>
                <div className="_col _wdp_4">
                  <div className="_cont">
                    <div className="_i_row _i_h0">
                      <div className="_i_col">주택임차료</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="_content">
                {viewData.map((cardData: any, idx: number) => {
                  const item = cardData.cardData || {};
                  return (
                    <div className="_row _i_h2" key={idx}>
                      <div className="_col _wdp_4">
                        <div className="_cont">
                          <div className="_i_row ">
                            <div className="_i_col _w_p_25">{addComma(item.use_place_cd02)}</div>
                          </div>
                        </div>
                      </div>
                      <div className="_col _wdp_4">
                        <div className="_cont">
                          <div className="_i_row ">
                            <div className="_i_col _w_p_25">{addComma(item.use_place_cd03)}</div>
                          </div>
                        </div>
                      </div>
                      <div className="_col _wdp_4">
                        <div className="_cont">
                          <div className="_i_row ">
                            <div className="_i_col _w_p_25">{addComma(item.use_place_cd04)}</div>
                          </div>
                        </div>
                      </div>
                      <div className="_col _wdp_4">
                        <div className="_cont">
                          <div className="_i_row ">
                            <div className="_i_col _w_p_25 _bor_n">
                              {addComma(item.use_place_cd05)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/*  */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditGridList;
